var _path, _g, _g2, _g3, _path2, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldTube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 87,
    viewBox: "0 0 19 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gold tube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4432 20.188V7.58851C18.5551 5.75342 17.5704 3.33647 17.5704 1.61327C17.5704 -0.109929 15.5563 0.00196662 15.5563 0.00196662H9.69296H8.77541H2.91207C2.91207 0.00196662 0.897939 -0.109929 0.897939 1.61327C0.897939 3.33647 -0.0867439 5.75342 0.0251521 7.58851V20.1656C0.0251521 20.1656 -0.310538 22.6945 1.97214 22.6945H8.75304C9.31252 22.6945 9.67058 22.6945 9.67058 22.6945H16.4515C18.7565 22.6945 18.3985 20.1656 18.3985 20.1656L18.4432 20.188Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6976_9163",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 18,
    height: 65
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.729 22.6499H0.765625V86.632H17.729V22.6499Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6976_9163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.62024 16.2939H8.85935C5.1638 16.2939 2.16797 19.2898 2.16797 22.9853V78.3514C2.16797 82.047 5.1638 85.0428 8.85935 85.0428H9.62024C13.3158 85.0428 16.3116 82.047 16.3116 78.3514V22.9853C16.3116 19.2898 13.3158 16.2939 9.62024 16.2939Z",
    fill: "white",
    stroke: "#555555",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.24609 3.51562V19.0244",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.41016 5.41748V19.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.0547 5.41748V19.024",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M15.6139 31.627H5.30078V74.2546H15.6139",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.0273 44.975L11.0273 45.3706L15.8101 45.3706L15.8101 44.975L11.0273 44.975Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.0273 44.5298L11.0273 44.7275L15.8101 44.7275L15.8101 44.5298L11.0273 44.5298Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.0273 43.8867L11.0273 44.0845L15.8101 44.0845L15.8101 43.8867L11.0273 43.8867Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.0273 42.8242L11.0273 43.022L15.8101 43.022L15.8101 42.8242L11.0273 42.8242Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.0273 41.9829L11.0273 42.1807L15.8101 42.1807L15.8101 41.9829L11.0273 41.9829Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.9961 40.9203L10.9961 41.3159L15.7788 41.3159L15.7788 40.9203L10.9961 40.9203Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.0273 40.4506L11.0273 40.6484L15.8101 40.6484L15.8101 40.4507L11.0273 40.4506Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.9961 39.2144L10.9961 39.8325L15.7788 39.8325L15.7788 39.2144L10.9961 39.2144Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.0273 38.1269L11.0273 38.3247L15.8101 38.3247L15.8101 38.1269L11.0273 38.1269Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.0273 38.5707L11.0273 38.9663L15.8101 38.9663L15.8101 38.5707L11.0273 38.5707Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.0273 37.2857L11.0273 37.9038L15.8101 37.9038L15.8101 37.2857L11.0273 37.2857Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11.0273 36.2231L11.0273 36.6187L15.8101 36.6187L15.8101 36.2231L11.0273 36.2231Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11.0273 35.7524L11.0273 35.9502L15.8101 35.9502L15.8101 35.7524L11.0273 35.7524Z",
    fill: "#004137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11.0273 54.601L11.0273 54.9966L15.8101 54.9966L15.8101 54.601L11.0273 54.601Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M11.0273 54.1557L11.0273 54.3535L15.8101 54.3535L15.8101 54.1557L11.0273 54.1557Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M11.0273 53.5131L11.0273 53.7109L15.8101 53.7109L15.8101 53.5132L11.0273 53.5131Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.0273 52.4497L11.0273 52.6475L15.8101 52.6475L15.8101 52.4497L11.0273 52.4497Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M11.0273 51.6093L11.0273 51.8071L15.8101 51.8071L15.8101 51.6093L11.0273 51.6093Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M10.9961 50.5458L10.9961 50.9414L15.7788 50.9414L15.7788 50.5458L10.9961 50.5458Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M11.0273 50.0771L11.0273 50.2749L15.8101 50.2749L15.8101 50.0771L11.0273 50.0771Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M10.9961 48.8409L10.9961 49.459L15.7788 49.459L15.7788 48.8409L10.9961 48.8409Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M11.0273 47.7534L11.0273 47.9512L15.8101 47.9512L15.8101 47.7534L11.0273 47.7534Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M11.0273 48.1972L11.0273 48.5928L15.8101 48.5928L15.8101 48.1972L11.0273 48.1972Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M11.0273 46.9117L11.0273 47.5298L15.8101 47.5298L15.8101 46.9117L11.0273 46.9117Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M11.0273 45.849L11.0273 46.2446L15.8101 46.2446L15.8101 45.849L11.0273 45.849Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M11.0273 45.3789L11.0273 45.5767L15.8101 45.5767L15.8101 45.3789L11.0273 45.3789Z",
    fill: "#004137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M11.0273 64.2265L11.0273 64.6221L15.8101 64.6221L15.8101 64.2265L11.0273 64.2265Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M11.0273 63.7812L11.0273 63.979L15.8101 63.979L15.8101 63.7812L11.0273 63.7812Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M11.0273 63.1386L11.0273 63.3364L15.8101 63.3364L15.8101 63.1386L11.0273 63.1386Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M11.0273 62.0756L11.0273 62.2734L15.8101 62.2734L15.8101 62.0757L11.0273 62.0756Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M11.0273 61.2343L11.0273 61.4321L15.8101 61.4321L15.8101 61.2343L11.0273 61.2343Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M10.9961 60.1718L10.9961 60.5674L15.7788 60.5674L15.7788 60.1718L10.9961 60.1718Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M11.0273 59.7026L11.0273 59.9004L15.8101 59.9004L15.8101 59.7026L11.0273 59.7026Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M10.9961 58.4664L10.9961 59.0845L15.7788 59.0845L15.7788 58.4664L10.9961 58.4664Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M11.0273 57.3784L11.0273 57.5762L15.8101 57.5762L15.8101 57.3784L11.0273 57.3784Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M11.0273 57.8227L11.0273 58.2183L15.8101 58.2183L15.8101 57.8227L11.0273 57.8227Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M11.0273 56.5372L11.0273 57.1553L15.8101 57.1553L15.8101 56.5372L11.0273 56.5372Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M11.0273 55.4745L11.0273 55.8701L15.8101 55.8701L15.8101 55.4745L11.0273 55.4745Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M11.0273 55.0044L11.0273 55.2021L15.8101 55.2021L15.8101 55.0044L11.0273 55.0044Z",
    fill: "#004137"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M10.9961 67.6225L10.9961 68.0181L15.7788 68.0181L15.7788 67.6225L10.9961 67.6225Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M10.9961 67.1767L10.9961 67.3745L15.7788 67.3745L15.7788 67.1767L10.9961 67.1767Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M10.9961 66.5341L10.9961 66.7319L15.7788 66.7319L15.7788 66.5341L10.9961 66.5341Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M10.9961 65.4712L10.9961 65.6689L15.7788 65.6689L15.7788 65.4712L10.9961 65.4712Z",
    fill: "#004137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M10.9961 64.6298L10.9961 64.8276L15.7788 64.8276L15.7788 64.6298L10.9961 64.6298Z",
    fill: "#004137"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M8.22356 47.491C8.22356 47.491 8.25173 47.4347 8.2799 47.4347L8.74466 47.4347C8.74466 47.4347 8.801 47.4628 8.801 47.491L8.801 49.1951C8.801 49.1951 8.77283 49.2655 8.73058 49.2655C7.39262 49.2515 6.56168 48.6459 6.56168 47.3783C6.56168 46.1671 7.39262 45.3784 8.64607 45.3784C9.89953 45.3784 10.7305 46.2094 10.7305 47.4628C10.7305 48.0966 10.5192 48.5613 10.1812 48.9134C10.153 48.9416 10.1249 48.9275 10.1108 48.9134L9.6601 48.5473C9.6601 48.5473 9.64602 48.5191 9.64602 48.505C9.64602 48.4909 9.64602 48.4768 9.6601 48.4628C9.81502 48.2938 10.0404 47.9135 10.0404 47.4487C10.0404 46.6178 9.4911 46.0685 8.66016 46.0685C7.82922 46.0685 7.27995 46.5896 7.27995 47.3783C7.27995 48.0262 7.60388 48.4346 8.23765 48.5473L8.23765 47.4769L8.22356 47.491Z",
    fill: "#9E8959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M10.7305 51.7861C10.7305 53.0395 9.89953 53.8564 8.64607 53.8564C7.39262 53.8564 6.56168 53.0395 6.56168 51.7861C6.56168 50.5326 7.39262 49.7017 8.64607 49.7017C9.89953 49.7017 10.7305 50.5326 10.7305 51.7861ZM7.26587 51.7861C7.26587 52.6029 7.81513 53.1663 8.64607 53.1663C9.47701 53.1663 10.0263 52.617 10.0263 51.7861C10.0263 50.9551 9.47702 50.4058 8.64607 50.4058C7.81513 50.4058 7.26587 50.9551 7.26587 51.7861Z",
    fill: "#9E8959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M7.24952 56.5335C7.24952 56.5335 7.23544 56.5898 7.19319 56.5898L6.67209 56.5898C6.67209 56.5898 6.61575 56.5617 6.61575 56.5335L6.61575 54.5759C6.61575 54.5759 6.64392 54.5195 6.67209 54.5195L10.6155 54.5195C10.6155 54.5195 10.6719 54.5477 10.6719 54.5759L10.6719 55.1674C10.6719 55.1674 10.6437 55.2237 10.6155 55.2237L7.24952 55.2237L7.24952 56.5335Z",
    fill: "#9E8959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M6.61575 57.2365C6.61575 57.2365 6.64392 57.1802 6.67209 57.1802L10.6155 57.1802C10.6155 57.1802 10.6719 57.2083 10.6719 57.2365L10.6719 58.4336C10.6719 59.673 9.88318 60.5039 8.64381 60.5039C7.40444 60.5039 6.61575 59.673 6.61575 58.4336L6.61575 57.2365ZM10.024 57.8844L7.29177 57.8844L7.29177 58.4336C7.29177 59.2646 7.82696 59.8138 8.6579 59.8138C9.48884 59.8138 10.024 59.2646 10.024 58.4336L10.024 57.8844Z",
    fill: "#9E8959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldTube);
export default __webpack_public_path__ + "static/media/gold-tube.2ac90191f11abbc65f02a578b05405f3.svg";
export { ForwardRef as ReactComponent };